module.exports = __webpack_public_path__ + "static/media/label.b498b2b9.svg";